import React from 'react'

const BigAnnounce = () => {
  return (
    <div className='md:my-5 my-2 '>
      <div className='w-full grid grid-cols-2 gap-2 border border-gray-300'>
        <div><img className='w-full' src="/images/Groccery/organic.jpg" alt="" /></div>
        <div><img className='w-full' src="/images/Groccery/favmilk.jpg" alt="" /></div>
        <div><img className='w-full' src="/images/Groccery/hotspot.jpg" alt="" /></div>
        <div><img className='w-full' src="/images/Groccery/fortuneoffer.jpg" alt="" /></div>
    
    </div>
    </div>
  )
}

export default BigAnnounce